import { Tooltip, TooltipProps } from "react-leaflet";
import "./LeafletTooltip.css";

interface LeafletTooltipProps {
  children?: React.ReactNode;
  tooltipProps?: TooltipProps;
  visible?: boolean;
  id?: string;
}

const LeafletTooltip = ({ children, tooltipProps, visible = true, id }: LeafletTooltipProps) => {
  const offsetKey = JSON.stringify(tooltipProps?.offset) || "default";

  return (
    <Tooltip
      key={id + offsetKey}
      pane="leafletTooltipPane"
      {...tooltipProps}
      opacity={visible ? tooltipProps?.opacity ?? 1 : 0}
      permanent={false}
      interactive={false}
      className={`${visible ? tooltipProps?.className || "" : "invisible-tooltip"} delayed-tooltip`}
    >
      {visible && children ? children : <span style={{ display: "none" }} />}
    </Tooltip>
  );
};

export default LeafletTooltip;
